import React, { useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Box, Button, Typography, Paper, Grid } from '@mui/material';
import { ScreenFrame, ConfirmDialog } from '../PrototypeShared';

export default function IncomingDetailScreen() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [approveModal, setApproveModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);

  const handleApprove = () => {
    setApproveModal(false);
    navigate('/prototype/incoming-deliveries');
  };

  const handleReject = () => {
    setRejectModal(false);
    navigate('/prototype/incoming-deliveries');
  };

  return (
    <ScreenFrame
      title={`Delivery ${id}`}
      actions={
        <>
          <Button component={Link} to="/prototype/incoming-deliveries" variant="outlined" size="small">Back to list</Button>
          <Button variant="outlined" color="error" size="small" onClick={() => setRejectModal(true)}>Reject</Button>
          <Button variant="contained" size="small" onClick={() => setApproveModal(true)}>Approve</Button>
        </>
      }
    >
      <Paper sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}><Typography variant="body2" color="text.secondary">Supplier</Typography><Typography>Supplier A</Typography></Grid>
          <Grid item xs={12} sm={6}><Typography variant="body2" color="text.secondary">Lot number</Typography><Typography>L2401260</Typography></Grid>
          <Grid item xs={12} sm={6}><Typography variant="body2" color="text.secondary">Production date</Typography><Typography>2024-02-15</Typography></Grid>
          <Grid item xs={12} sm={6}><Typography variant="body2" color="text.secondary">Expiry date</Typography><Typography>2024-08-15</Typography></Grid>
          <Grid item xs={12}><Typography variant="body2" color="text.secondary">Remarks</Typography><Typography>VOR 2401372</Typography></Grid>
        </Grid>
      </Paper>
      <Box sx={{ mt: 2 }}>
        <Button component={Link} to="/prototype/incoming-deliveries/stock" variant="outlined" size="small">View in stock</Button>
      </Box>
      <ConfirmDialog open={approveModal} title="Approve delivery" message="Approve this incoming delivery? This action will be logged." onConfirm={handleApprove} onCancel={() => setApproveModal(false)} />
      <ConfirmDialog open={rejectModal} title="Reject delivery" message="Reject this delivery? You can add a reason in the next step." onConfirm={handleReject} onCancel={() => setRejectModal(false)} confirmLabel="Reject" />
    </ScreenFrame>
  );
}
